// extracted by mini-css-extract-plugin
module.exports = {"embedContainer":"CalEmbed_embedContainer__1b4Ys"};